
<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="item.path" v-for="(item, index) in breadcrumbList" :key="index">{{ item.name
            }}</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="课程状态：">
                <el-select style="width: 100px;" size="small" v-model="formInline.type" placeholder="请选择">
                    <el-option v-for="type in type" :label="type.key" :value="type.value" :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属平台：">
                <el-select style="width: 100px;" size="small" v-model="formInline.is_platform" placeholder="请选择">
                    <el-option v-for="type in is_platform" :label="type.key" :value="type.value"
                        :key="type.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.lid" placeholder="输入讲师id"></el-input>
            </el-form-item>
            <el-form-item label="搜索：">
                <el-input size="small" v-model="formInline.title" placeholder="输入课程名称"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item v-if="userinfo.Permissions_type != 3">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">添加</el-button>
            </el-form-item>
        </el-form>
        <!--列表-->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="40">
            </el-table-column>
            <el-table-column prop="cid" label="ID" width="60">
            </el-table-column>
            <el-table-column prop="title" label="课程名称" width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="type" label="课程状态" width="80" show-overflow-tooltip>、
                <template slot-scope="{row}">
                    <div v-if="row.type == 0">待完结</div>
                    <div v-else>已完结</div>
                </template>
            </el-table-column>
            <el-table-column prop="is_platform" label="课程所属平台" width="100" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div v-if="row.is_platform == 0">抖音</div>
                    <div v-else>快手</div>
                </template>
            </el-table-column>
            <el-table-column prop="list_img" label="列表图" width="60">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.list_img" class="table_list_pic"
                            :src="scope.row.list_img" :preview-src-list="[scope.row.list_img]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="course_img" label="详情展示图" width="100">
                <template slot-scope="scope">
                    <div class="demo-image__preview">
                        <el-image style="height: 24px;" v-if="scope.row.course_img" class="table_list_pic"
                            :src="scope.row.course_img" :preview-src-list="[scope.row.course_img]"></el-image>
                        <div v-else>暂无图片</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="detail" label="详情介绍" width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="price" label="课程价格" width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="discount_price" label="折扣价格" width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="status" label="审核状态" width="180" show-overflow-tooltip>、
                <template slot-scope="{row}">
                    <div v-if="row.status == 0"> 0未提交</div>
                    <div v-else-if="row.status == 1">1资料提交成功待审核</div>
                    <div v-else-if="row.status == 2">2资料审核通过待上传课程</div>
                    <div v-else-if="row.status == 3">3资料审核不通过待重新提交资料</div>
                    <div v-else-if="row.status == 4">4上传课程成功待审核</div>
                    <div v-else-if="row.status == 5">5上传课程审核成功</div>
                    <div v-else-if="row.status == 6">6上传课程审核失败待修改资料重新提交</div>
                    <div v-else>7课程下架</div>
                </template>
            </el-table-column>
     
            <el-table-column prop="create_time" label="添加时间" width="140" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="update(scope.row)"><i class="el-icon-edit" />修改</el-button>
                    <el-button size="mini" type="success" @click="Coursedetsils(scope.row)"><i class="el-icon-edit-outline" />课程</el-button>
                     <el-dropdown trigger="click" style="margin-left: 10px;">
                    <el-button size="mini" type="info">更多操作</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-button size="mini" type="success" @click="shenh(scope.row)"><i class="el-icon-edit-outline" />上传材料</el-button>
                                <el-button size="mini" type="success" @click="detail(scope.row)"><i class="el-icon-edit-outline" />查看材料上传状态</el-button>
                                <el-button size="mini" type="success" @click="shenh1(scope.row)"><i class="el-icon-edit-outline" />上传课程</el-button>
                                <el-button size="mini" type="success" @click="detail1(scope.row)"><i class="el-icon-edit-outline" />查看课程上传状态</el-button>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <Add :show.sync="dialog.addDialogStatus" @refesh_list="getdata"></Add>
        <Update :info="updateInfo" :show.sync="dialog.updateDialogStatus" size="small" @refesh_list="getdata"></Update>
        <CourseDetails :cid="cid" :show.sync="dialog.detailsDialogStatus"></CourseDetails>
    </div>
</template>
    
<script>
import { getCourse, getCourseUpload, getCourseStatus, getCourseSet, getCourseDel,getCouradd,getCouraddStatus,getStatuscourse } from '../../api/userMG';
import Pagination from '../../components/Pagination';
import timestampToTime from '../../utils/util.js';
import Add from './add.vue';
import Update from './update.vue';
import CourseDetails from './coursedetail.vue';
export default {
    // 注册组件
    components: {
        Pagination, Add, Update,CourseDetails
    },
    data() {
        return {
            type: [ //0待完结 1已完结
                { key: '请选择', value: '' },
                { key: '待完结', value: 0 },
                { key: '已完结', value: 1 },
            ],
            is_platform: [ //0抖音 1快手
                { key: '请选择', value: '' },
                { key: '抖音', value: 0 },
                { key: '快手', value: 1 },
            ],
            dialog: {
                addDialogStatus: false,
                updateDialogStatus: false,
                detailsDialogStatus:false  //课程列表
            },
            updateInfo: {},
            loading: false, //是显示加载
            formInline: {
                title: '',
                type: '',
                is_platform: '',
                apid: '',
                lid: '',
                page: 1
            },
            listData: [],
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            userinfo: {},
            cid:0,
            isok:false
        }
    },
    created() {
        this.getdata()
        this.generateBreadcrumb()
        this.userinfo = JSON.parse(localStorage.getItem('userdata'))
        console.log(this.userinfo.Permissions_type, '=-0------');
    },
    watch: {
        $route() {
            this.generateBreadcrumb()
        }
    },
    methods: {
        swchange(row){
            console.log(row.cid);
            getStatuscourse({cid:row.cid}).then(res=>{
                console.log(res);
            })
        },
        add() {
            this.dialog.addDialogStatus = true
        },
        search() {
            this.formInline.page = 1
            this.getdata(this.formInline)
        },
        Coursedetsils(row){
            console.log(row.cid);
            this.cid = row.cid*1
            this.dialog.detailsDialogStatus = true
        },

        update(row) {
            getCourseSet({ cid: row.cid, echo: 'get' }).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.dialog.updateDialogStatus = true
                    this.updateInfo = res.info
                }
            })
        },
        detail(row) {
            getCourseStatus({ cid: row.cid }).then(res => {
                console.log(res.msg);
                if (res.code == 200) {
                    this.$confirm(res.info, '课程材料上传状态', {
                        confirmButtonText: '确定',
                    })
                } else {
                    this.$message({ message: res.msg, type: 'error' })
                }
            })
        },
        detail1(row) {
            getCouraddStatus({ cid: row.cid }).then(res => {
                console.log(res.msg);
                if (res.code == 200) {
                    this.$confirm(res.msg, '课程上传状态', {
                        confirmButtonText: '确定',
                    })
                } else {
                    this.$message({ message:res.msg, type: 'error' })
                }
            })
        },
        del(row) {
            this.$confirm('确定要删除吗?', '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                getCourseDel({ cid: row.cid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '删除成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: '删除失败', type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    })
                })
        },
        shenh(row) {
            this.$confirm('确定上传课程材料吗?', '上传课程材料', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning '
            }).then(() => {
                getCourseUpload({ cid: row.cid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '上传成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: res.msg, type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
        },
        shenh1(row) {
            this.$confirm('确定上传课程吗?', '上传课程', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning '
            }).then(() => {
                getCouradd({ cid: row.cid }).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '上传成功', type: 'success' })
                        this.getdata()
                    } else {
                        this.$message({ message: res.msg, type: 'error' })
                    }
                })
            })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
        },
        generateBreadcrumb() {
            // 获取当前路由信息
            const matched = this.$route.matched
            console.log(matched, '++++++++++');
            // 初始化面包屑导航数据
            const breadcrumbList = []
            // 遍历路由信息，生成面包屑导航数据
            matched.forEach(item => {
                const { meta, name, path } = item
                if (meta.requireAuth) {
                    breadcrumbList.push({
                        name,
                        path
                    })
                }
            })
            // 保存面包屑导航数据
            this.breadcrumbList = breadcrumbList
        },
        getdata() {
            this.loading = true
            getCourse(this.formInline).then(res => {
                console.log(res);
                if (res.code == 200) {
                    this.listData = res.info.data
                    this.pageparm.total = res.info.total
                    this.loading = false

                }
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
    
<style scoped>
.user-search {
    margin-top: 20px;
}

.userRole {
    width: 100%;
}
</style>
    
     
     


// WEBPACK FOOTER //
// src/views/course/index.vue